import React, { createContext, useContext } from 'react'
import { Nav, NavItem, NavLink, TabContent as TabContent0, TabPane as TabPage0 } from 'reactstrap'
import Resx from '@/components/Resx'
import classNames from 'classnames'
import Icon from '@/components/Icon'

const TabContext = createContext({ activeTab: 1, renderActiveOnly: false })

function TabNavItems ({ items, onClick, activeTabId, children, buttonView }) {
  return (
    <Nav className={buttonView && 'button-view'} tabs>
      {items.map(item => (
        <NavItem key={item.id}>
          <NavLink
            className={classNames({ active: activeTabId === item.id, readonly: item.readonly })}
            onClick={() => {
              onClick(item.id)
            }}
          >
            {typeof item.icon === 'string' && <Icon name={item.icon} />}
            {typeof item.text === 'string' ? <span><Resx name={item.text} /></span> : item.text}
          </NavLink>
        </NavItem>
      ))}
      {children || null}
    </Nav>
  )
}

function TabPane (props) {
  const { activeTab, renderActiveOnly } = useContext(TabContext)
  return (!renderActiveOnly || activeTab === props.tabId)
    ? <TabPage0 {...props} />
    : null
}

function TabContent ({ renderActiveOnly, ...props }) {
  return (
    <TabContext.Provider value={{ activeTab: props.activeTab, renderActiveOnly }}>
      <TabContent0 {...props} />
    </TabContext.Provider>
  )
}

export {
  TabNavItems,
  TabContent,
  TabPane
}



// WEBPACK FOOTER //
// ./src/components/tabs.js